import set from './set';

export default {
  set,
};



// WEBPACK FOOTER //
// ./src/actions/shared/index.js